<template>
    <div id="baseHeader">
        <div class="trade-header">
            <div class="trade-logo-tlt">
                <img src="~@/assets/images/logos.png"/><span>交易端</span>
            </div>
            <div class="trade-rt">
                <div class="trade-user" @click="changeAccountOpen()">
                    <div class="trade-user-icon"><img src="~@/assets/images/user.png"/></div>
                    <span class="t-txt">{{now_trade_account}}</span>
                    <div class="trade-down"><img src="~@/assets/images/down.png"/></div>
                    <transition name="fade">
                        <div class="user-wrap-tan" v-if="accountChangeIng">
                            <div class="user-tb" @click="changeAccount(account.account)" v-for="account in accounts" :key="account.account">{{account.account}}</div>
                        </div>
                    </transition>

                </div>
                <div class="trade-h-btn addcount" @click="addUserFun()">增加账户</div>
                <div class="trade-h-btn eidtpwd" @click="editPassFun()">修改密码</div>
                <div class="trade-h-line"></div>
                <el-search></el-search>
<!--                <div class="trade-chuang-box">-->
<!--                    <div @click="closeExt(1)" class="chuang-box icon1"></div>-->
<!--                    <div @click="closeExt(2)" class="chuang-box icon2"></div>-->
<!--                    <div @click="closeExt(3)" class="chuang-box icon3"></div>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import BaseHeaderSearch from './BaseHeaderSearch'
    export default {
        name: "BaseHeader",
        components: {'el-search': BaseHeaderSearch},
        created(){
        },
        methods: {
            addUserFun() {
                this.$emit('addUser', true);
            },
            editPassFun() {
                this.$emit('editPass', true);
            },

            changeAccountOpen() {
                this.accountChangeIng = !this.accountChangeIng;
            },
            changeAccount(account) {
                this.$store.commit('CHANGE_ACCOUNT', account);
            },
        },
        data: function () {
            return {
                accountChangeIng: false
            }
        },
        computed: {
            now_trade_account: function () {
                return this.$store.state.now_trade_account;
            },
            accounts: function () {
                return this.$store.state.accounts;
            }
        }
    }
</script>

<style scoped>
    .trade-logo-tlt img{
        margin-top: -6px;
    }
</style>
